export enum FooterTheme {
  DARK = 'dark',
  LIGHT = 'light',
}
